<!-- 节气海报 -->
<!-- 由 suu 创建于 2023-01-11 星期三 -->
<template>
  <div class="birthday-pop" v-if="user && popInfo">
    <div class="stp-mask"></div>
    <div
      class="stp-cent animate__animated animate__fadeIn"
      :class="[genderClass]"
      v-if="!showPoster"
    >
      <img class="c-head" :src="user.heard_img" alt="" />
      <img class="c-hdj" :src="iconHdj" alt="" />
      <img class="c-mz" :src="iconMz" alt="" />
      <img class="c-bg" :src="bgImg" alt="" />
      <div class="c-title">
        <div
          >亲爱的{{ user.user_is_vvip ? '超伙' : 'V' + popInfo.grade }}会员</div
        >
        <div class="true-name"
          >【<span>{{ popInfo.truename | filterTruename }}</span
          >】</div
        >
      </div>
      <div class="birthday-text" v-if="user">{{
        user.birthday | filterBirthday
      }}</div>
      <div class="red-text birthday-num" v-if="user.gender == 'F'">{{
        popInfo.birthday_num
      }}</div>
      <div class="red-text age" v-if="user.gender == 'M'">{{
        popInfo.age
      }}</div>
      <div class="red-text online-day">{{ popInfo.add_day }}</div>
      <img class="c-btn-get user-btn" :src="btnGetImg" @click="getImg" alt="" />
      <img
        class="c-close"
        @click="close"
        src="https://cdnvue.gymcity.com.cn/uploads/b9613ad5441024843dc083a522a19d9e.webp"
      />
    </div>
    <div
      class="stp-cent stp-cent-getimging"
      :class="[genderClass]"
      v-if="getImgIng"
    >
      <div class="getimging-container" id="box">
        <img class="c-head" :src="user.heard_img" alt="" />
        <img class="c-hdj" :src="iconHdj" alt="" />
        <img class="c-mz" :src="iconMz" alt="" />
        <img class="c-bg" :src="bgImg" alt="" />
        <div class="c-title">
          <div
            >亲爱的{{
              user.user_is_vvip ? '超伙' : 'V' + popInfo.grade
            }}会员</div
          >
          <div class="true-name"
            >【<span>{{ popInfo.truename | filterTruename }}</span
            >】</div
          >
        </div>
        <div class="birthday-text" v-if="user">{{
          user.birthday | filterBirthday
        }}</div>
        <div class="red-text birthday-num" v-if="user.gender == 'F'">{{
          popInfo.birthday_num
        }}</div>
        <div class="red-text age" v-if="user.gender == 'M'">{{
          popInfo.age
        }}</div>
        <div class="red-text online-day">{{ popInfo.add_day }}</div>
      </div>
    </div>
    <div v-if="showPoster" class="stp-cent stp-cent-show">
      <div class="cent-wrap animate__animated animate__zoomIn">
        <img
          class="c-bg c-bg-show"
          :src="imgUrl"
          @touchstart="gtouchstart()"
          @touchmove="gtouchmove()"
          @touchend="gtouchend()"
          alt
        />
        <div
          class="save-poster"
          v-if="isApp && !isHarmony"
          @click="bindSavePoster"
          >保存海报</div
        >
        <img class="c-btn" :src="btnImg" v-else alt="" />
        <img
          class="c-close"
          @click="close"
          src="https://cdnvue.gymcity.com.cn/uploads/b9613ad5441024843dc083a522a19d9e.webp"
        />
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
//判断是否符合日期
const isDateValid = function (dateInput) {
  if (!dateInput) return false
  const dateReg = /^(?:\d{4})-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])$/
  if (!dateReg.test(dateInput)) return false
  const [year, month, day] = dateInput.split('-').map(Number)
  const testDate = new Date(year, month - 1, day)
  return (
    testDate.getFullYear() === year &&
    testDate.getMonth() === month - 1 &&
    testDate.getDate() === day
  )
}
export default {
  name: 'birthday-pop',
  components: {},

  props: {
    popInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      btnGetImg:
        'https://cdnvue.gymcity.com.cn/uploads/m-birthday-btn-getimg?v=1',
      btnImg: 'https://cdnvue.gymcity.com.cn/uploads/m-birthday-btn',
      iconHdj:
        'https://cdnvue.gymcity.com.cn/uploads/2025-12-23-birthday-pop-bow',
      iconMz:
        'https://cdnvue.gymcity.com.cn/uploads/2025-12-23-birthday-pop-hat',
      imgUrl: '',
      showPoster: false,
      getImgIng: false,
      timeOutEvent: 0,
      genderData: {
        M: 'man',
        F: 'women'
      }
    }
  },
  filters: {
    filterBirthday(str) {
      if (!isDateValid(str)) {
        return ''
      }
      let list = str.split('-')
      return `${list[1]}/${list[2]}`
    },
    filterTruename(truename) {
      let truenameArr = Array.from(truename)
      if (truenameArr.length > 12) {
        let list = truenameArr.slice(0, 13)
        return `${list.join('')}...${truenameArr[truenameArr.length - 1]}`
      } else {
        return truename
      }
    }
  },
  computed: {
    bgImg() {
      if (this.user) {
        return `https://cdnvue.gymcity.com.cn/uploads/2025-12-23-birthday-pop-${
          this.genderData[this.user.gender] || 'unknown'
        }`
      } else {
        return ''
      }
    },
    user() {
      return this['$store'].state.user.user
    },
    genderClass() {
      if (this.user) {
        return `content-${this.genderData[this.user.gender] || 'unknown'}`
      } else {
        return ''
      }
    },
    isApp() {
      return this.$betterwe.isApp()
    },
    isHarmony() {
      return this.$betterwe.isHarmony()
    }
  },
  mounted() {
    this['$http'].get(
      'member/index?a=shareLogPush',
      {
        from: `会员生日弹窗-曝光`,
        from_id: 241008
      },
      true
    )
  },
  methods: {
    close() {
      this.showPoster = false
      this['$http'].get(
        'member/index?a=shareLogPush',
        {
          from: `会员生日弹窗-关闭`,
          from_id: 241008
        },
        true
      )
      this.$emit('close')
    },
    longTap() {},
    /**
     * 生成海报
     */
    getImg() {
      this.$toast.loading('正在生成海报...')
      this.getImgIng = true
      setTimeout(() => {
        this.$nextTick(() => {
          html2canvas(document.getElementById('box'), {
            backgroundColor: null,
            useCORS: true
          })
            .then((canvas) => {
              this.$toast.clear()
              this.imgUrl = canvas.toDataURL()
              this.$emit('over')
              this.showPoster = true
              this.getImgIng = false
              setTimeout(() => {
                this.$toast({
                  message:
                    this.isApp && !this.isHarmony
                      ? '海报已生成，点击保存分享给您的好友吧'
                      : '海报已生成，长按保存分享给您的好友吧',
                  duration: 3000
                })
              }, 100)
            })
            .catch((err) => {
              this.$toast.clear()
              this.getImgIng = false
            })
        })
      }, 100)
      this['$http'].get(
        'member/index?a=shareLogPush',
        {
          from: `会员生日弹窗-生成海报`,
          from_id: 241008
        },
        true
      )
    },
    // 开始按
    gtouchstart() {
      const that = this
      this.timeOutEvent = setTimeout(function () {
        that.longPress()
      }, 450) // 这里设置定时器，定义长按500毫秒触发长按事件，时间可以自己改，个人感觉500毫秒非常合适
      return false
    },
    // 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gtouchend() {
      clearTimeout(this.timeOutEvent) // 清除定时器
      if (this.timeOutEvent !== 0) {
        // 这里写要执行的内容（尤如onclick事件）
      }
      return false
    },
    // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gtouchmove() {
      clearTimeout(this.timeOutEvent) // 清除定时器
      this.timeOutEvent = 0
    },
    // 真正长按后应该执行的内容
    longPress() {
      this.timeOutEvent = 0
      this['$http'].get(
        'member/index?a=shareLogPush',
        {
          from: `会员生日弹窗-长按海报`,
          from_id: 241008
        },
        true
      )
    },
    bindSavePoster() {
      this.$betterwe.onAppSaveImage({ data: this.imgUrl, type: 'base64' })
      this.$emit('close')
      this['$http'].get(
        'member/index?a=shareLogPush',
        {
          from: `会员生日弹窗-保存海报`,
          from_id: 241008
        },
        true
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.birthday-pop {
  display: flex;
  flex-direction: column;
  align-items: center;

  .stp-mask {
    background-color: #000;
    position: fixed;
    top: 0;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    z-index: 99;
  }

  .stp-cent {
    width: 100vw;
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;

    img {
      display: block;
    }

    .c-head {
      width: vw(50);
      height: vw(50);
      box-sizing: border-box;
      border-radius: 50%;
      position: absolute;
      z-index: 1;
      top: vw(28);
    }

    .c-hdj {
      width: vw(96);
      position: absolute;
      z-index: 2;
      top: vw(53);
    }

    .c-mz {
      width: vw(35);
      position: absolute;
      z-index: 2;
      top: vw(4);
      left: vw(194);
    }

    .c-title {
      font-family: PingFangSC, PingFang SC;
      font-size: vw(17);
      color: #7e5236;
      line-height: vw(24);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: vw(112);

      .true-name {
        text-align: center;
        width: vw(300);
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    .birthday-text {
      position: absolute;
      left: vw(53);
      top: vw(352);
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      line-height: vw(22);
      height: vw(22);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: vw(12);
      color: #7e5236;
    }

    .red-text {
      white-space: nowrap;
      text-align: center;
      font-weight: 600;
      color: rgba(255, 6, 79, 1);
      font-size: vw(18);
      height: vw(24);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .c-text {
      width: vw(268);
      box-sizing: border-box;
      font-size: vw(12);
      font-weight: 600;
      color: #7e5236;
      position: absolute;
      top: vw(369);
      text-align: left;
      line-height: vw(24);
      text-decoration: underline;
      text-decoration-style: dashed;
      text-decoration-thickness: 1px;
      text-decoration-color: rgba($color: #7e5236, $alpha: 0.2);
      text-underline-offset: vw(6);

      .t-top {
        span {
          font-size: vw(18);
          color: #ff064f;
        }
      }
    }

    .c-text-1 {
      top: vw(355);
      line-height: vw(23);
      text-underline-offset: vw(5);
    }

    .c-bg {
      width: 100%;
      min-height: vw(503);
    }

    .c-bg-show {
      // border-radius: vw(6);
    }

    .c-btn {
      width: vw(123);
      margin-top: vw(12);
    }

    .c-btn-get {
      width: vw(90);
      margin-top: vw(6);
    }
    .save-poster {
      margin-top: vw(20);
      border: 1px solid rgba(255, 255, 255, 0.8);
      padding: 0px vw(16);
      color: rgba(255, 255, 255, 0.8);
      font-size: vw(14);
      height: vw(30);
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: vw(15);
      margin-bottom: vw(10);
    }
    #qrCode-canvas {
      width: vw(50) !important;
      height: vw(50) !important;
      position: absolute;
      top: vw(442);
      right: vw(22);
    }
  }

  .stp-cent-getimging {
    top: vw(9999);
    // border-top: vw(10) solid #D6A464;

    .c-text {
      line-height: vw(22);
      text-decoration: none;
      // text-underline-offset: vw(4);
    }

    .getimging-container {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: linear-gradient(180deg, #d5a363 0%, #ebcf9d 100%);
      padding-bottom: vw(18);
    }
  }

  .stp-cent-show {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.9);
    z-index: 100;

    .cent-wrap {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .c-close {
    width: vw(20);
    margin-top: vw(25);
  }

  .content-man {
    /*  .birthday-num {
      width: vw(30);
      position: absolute;
      left: vw(103);
      top: vw(373);
      text-align: center;
    } */

    .age {
      width: vw(30);
      position: absolute;
      left: vw(103);
      top: vw(372);
      text-align: center;
    }

    .online-day {
      width: vw(48);
      position: absolute;
      left: vw(192);
      top: vw(394);
    }
  }

  .content-women {
    .birthday-text {
      left: vw(53);
      top: vw(346);
    }

    .birthday-num {
      width: vw(30);
      position: absolute;
      left: vw(166);
      top: vw(366);
      text-align: center;
    }

    .age {
      width: vw(30);
      position: absolute;
      left: vw(103);
      top: vw(372);
      text-align: center;
    }

    .online-day {
      width: vw(50);
      position: absolute;
      left: vw(128);
      top: vw(388);
    }
  }

  .content-unknown {
    .birthday-text {
      left: vw(53);
      top: vw(364);
    }

    .birthday-num {
      width: vw(30);
      position: absolute;
      left: vw(103);
      top: vw(372);
      text-align: center;
    }

    .age {
      width: vw(30);
      position: absolute;
      left: vw(103);
      top: vw(372);
      text-align: center;
    }

    .online-day {
      width: vw(52);
      position: absolute;
      left: vw(201);
      top: vw(384);
    }
  }

  @media (max-height: 700px) {
    /* 在屏幕宽度小于或等于600px时应用的样式 */
    .stp-cent-show {
      top: 50%;
      transform: translate(-50%, -55%) scale(0.8);
    }

    .stp-cent {
      top: 50%;
      transform: translate(-50%, -55%) scale(0.8);
    }
  }
}
</style>
